import { AutogenModelEdiCrossRefPackageTypeCode, AutogenRowEdiCrossRefPackageTypeCode } from "./autogen/AutogenModelEdiCrossRefPackageTypeCode";

export class ModelEdiCrossRefPackageTypeCode extends AutogenModelEdiCrossRefPackageTypeCode<RowEdiCrossRefPackageTypeCode> {
	constructor() {
		super(RowEdiCrossRefPackageTypeCode);
	}
}

export class RowEdiCrossRefPackageTypeCode extends AutogenRowEdiCrossRefPackageTypeCode {
}